<template>
  <div>
    <div class="d-flex">
      <div class="side-frame-success"></div>
      <div>
        <span style="font-size: 14px; color: #606266">
          Tc Fabric Purchase No：{{ formData.tcFabricPurchaseNo || 'New' }}
        </span>
        <el-divider direction="vertical"></el-divider>
        <b-badge
          style="font-size: 12px"
          :variant="
            formData.tcPurchaseStatus === 'Y'
              ? 'success'
              : formData.tcPurchaseStatus === 'D'
              ? 'danger'
              : 'primary'
          "
        >
          {{ formData.v_tcPurchaseStatus }}
        </b-badge>
        <el-divider direction="vertical"></el-divider>
        <span style="font-size: 14px; color: #606266">
          Update：{{ formData.modifyByName || '--' }} at
          {{ formData.modifyTime || '--' }}
        </span>
      </div>
    </div>
    <el-form
      ref="form"
      :model="formData"
      :rules="rules"
      :disabled="disabled"
      size="mini"
    >
      <el-row :gutter="10">
        <el-col :span="6">
          <el-form-item
            :label="$l('INDEX.purchase_form_label_scmCode') || '供应商'"
            prop="scmCode"
          >
            <dict-select
              v-model="formData.scmCode"
              url="/master/common/dict/scmPartners"
              :placeholder="$l('INDEX.tips_select_data') || '请选择……'"
              size="mini"
              clearable
              filterable
            ></dict-select>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item :label="$l('form_label_buyScmCode') || '采购方'">
            <!-- prop="buyScmCode" -->
            <!-- <dict-select
              v-model="formData.buyScmCode"
              url="/master/common/dict/scmPartners"
              :placeholder="$l('INDEX.tips_select_data') || '请选择……'"
              size="mini"
              clearable
              filterable
            ></dict-select> -->
            <el-input v-model="formData.buyScmName" readonly> </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item
            :label="$l('tc_fabric_purchase_tcPurchaseDate') || '采购日期'"
          >
            <el-date-picker
              v-model="formData.tcPurchaseDate"
              type="date"
              value-format="yyyy-MM-dd"
              :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
              style="width: 100%"
            ></el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item
            :label="$l('INDEX.order_form_label_salesPersonCode') || '业务人员'"
          >
            <el-input v-model="formData.salesPersonName" readonly> </el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="6">
          <el-form-item
            :label="$l('tc_fabric_purchase_fabricAmount') || 'TC面料金额'"
          >
            <el-input v-model="v_fabricAmount" readonly> </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item
            :label="$l('tc_fabric_purchase_surcharge') || '附加费用'"
          >
            <el-input-number
              v-model="formData.surcharge"
              style="width:100%"
              :precision="4"
              :min="0"
              :step="0.01"
              controls-position="right"
              :placeholder="$l('INDEX.tips_input_placeholder') || '请输入...'"
            >
            </el-input-number>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item
            :label="$l('tc_fabric_purchase_totalAmount') || '金额合计'"
          >
            <el-input v-model="v_totalAmount" readonly> </el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="24">
          <el-form-item :label="$l('tc_fabric_purchase_remark') || '备注说明'">
            <el-input
              v-model="formData.remark"
              :placeholder="$l('INDEX.tips_input_placeholder') || '请输入...'"
              type="textarea"
              maxlength="500"
              show-word-limit
              :autosize="{ minRows: 2, maxRows: 4 }"
            >
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <div class="d-flex mt-2">
        <div class="side-frame-danger"></div>
        <div style="font-size: 14px; color: #606266">
          <span>
            {{ '原订单信息' }}
          </span>
          <el-divider direction="vertical"></el-divider>
          <span> Order No：{{ formData.orderNo || '' }} </span>
        </div>
      </div>
      <el-row :gutter="10">
        <el-col :span="6">
          <el-form-item
            :label="$l('INDEX.order_form_label_custCode') || '下单客户'"
          >
            <el-input v-model="formData.custName" readonly> </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item
            :label="$l('INDEX.order_form_label_endCustCode') || '终端客户'"
          >
            <el-input v-model="formData.endCustName" readonly> </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item
            :label="$l('INDEX.order_form_label_scmCode') || '执行工厂'"
          >
            <el-input v-model="formData.executeScmName" readonly> </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item
            :label="$l('INDEX.order_form_label_orderScmCode') || '名义工厂'"
          >
            <el-input v-model="formData.orderScmName" readonly> </el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <div class="mt-2">
      <FabricTable
        ref="fabricTable"
        :tableData="formData.listFabric"
        :orderCode="formData.orderCode"
        :disabled="disabled"
        @totalAmountChange="(e) => (formData.fabricAmount = e)"
      />
    </div>
    <div class="d-flex mt-2">
      <div class="side-frame-warning"></div>
      <div>
        <span style="font-size: 14px; color: #606266">
          Create：{{ formData.createByName || '--' }} at
          {{ formData.createTime || '--' }}
        </span>
        <el-divider direction="vertical"></el-divider>
        <span style="font-size: 14px; color: #606266">
          Review：{{ formData.reviewByName || '--' }} at
          {{ formData.reviewTime || '--' }}
        </span>
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions } from 'vuex'
import { add } from '@/libs/util.number.js'
import validate from '@/libs/util.validate'
import EditLoading from '@/mixins/edit-loading'
import FabricTable from '../fabric-table'
export default {
  components: { FabricTable },
  mixins: [EditLoading],
  props: {
    tcFabricPurchaseCode: { type: String, default: '' },
    tcOrderCode: { type: String, default: '' },
    disabled: { type: Boolean, default: true },
  },
  data() {
    return {
      formData: {},
      rules: {
        scmCode: [
          {
            required: true,
            message: this.$l('INDEX.tips_select_placeholder') || '请选择',
            trigger: 'change',
          },
        ],
        buyScmCode: [
          {
            required: true,
            message: this.$l('INDEX.tips_select_placeholder') || '请选择',
            trigger: 'change',
          },
        ],
      },
    }
  },
  computed: {
    totalAmount() {
      const { fabricAmount, surcharge } = this.formData
      return add(fabricAmount, surcharge)
    },
    v_totalAmount() {
      return this.totalAmount.toLocaleString()
    },
    v_fabricAmount() {
      const { fabricAmount } = this.formData
      return (fabricAmount || 0).toLocaleString()
    },
  },
  mounted() {
    this.getData()
  },
  methods: {
    ...mapActions('admin/page', ['close']),
    async getData() {
      let res = {}

      if (this.tcFabricPurchaseCode) {
        res = await this.$api
          .tcFabricPurchaseDetailApi({
            tcFabricPurchaseCode: this.tcFabricPurchaseCode,
          })
          .catch(() => null)
      }

      if (this.tcOrderCode) {
        res = await this.$api
          .tcFabricPurchaseCreateDataApi({
            tcOrderCode: this.tcOrderCode,
          })
          .catch(() => null)
      }

      const { status, body } = res || {}
      if (202 === status) {
        this.closeCurPage()
        return
      }

      this.formData = body || {}
    },
    async save() {
      if (!(await this.validate())) return

      const listFabric = this.$refs.fabricTable.getTableData()
      if (!listFabric || !listFabric.length) {
        this.$message.error('请添加TC面料采购单明细')
        return
      }

      this.loadingOpen()
      const res = await this.$api
        .tcFabricPurchaseSaveApi({
          ...this.formData,
          listFabric,
          totalAmount: this.totalAmount,
        })
        .catch(() => null)
      this.loadingClose()
      const { status } = res || {}
      if (status !== 200) {
        this.$message.error(this.$l('INDEX.tips_save_no') || '保存失败！')
        return
      }
      this.$message({
        showClose: true,
        message: this.$l('INDEX.tips_save_ok') || '保存成功！',
        type: 'success',
      })
      if (this.tcFabricPurchaseCode) {
        this.getData()
      } else {
        this.closeCurPage()
      }
    },
    async validate() {
      const mainResult = await validate.formValidate([this.$refs.form])
      const detailResult = await this.$refs.fabricTable.validate()
      return mainResult && detailResult
    },
    closeCurPage() {
      // 关闭当前页面
      this.close({
        tagName: this.$route.fullPath,
        showConfirm: false,
      })
    },
  },
}
</script>
<style lang="scss" scoped>
.side-frame-success {
  padding: 1px 5px;
  border-left: 3px solid $color-success;
  height: 20px;
  margin-top: 3px;
}
.side-frame-warning {
  padding: 1px 5px;
  border-left: 3px solid $color-warning;
  height: 20px;
  margin-top: 3px;
}
.side-frame-danger {
  padding: 1px 5px;
  border-left: 3px solid $color-danger;
  height: 20px;
  margin-top: 3px;
}
</style>
